import React, { Component } from 'react'
import styled from 'styled-components'
import ImageContainer from '@Components/ImageContainer'
import media from '@Styles/media'
import { isDataURI, isURL } from 'validator'

class HubLogo extends Component {
  static isUrl = (url) => typeof url === 'string' && (isURL(url) || isDataURI(url))

  render() {
    const { url, useImageContainer = true, ...rest } = this.props
    if (!url) return null
    if (!HubLogo.isUrl(url)) return null

    return useImageContainer ? (
      <ICLogo url={url} resolutionScale={0} op="contain" {...rest} />
    ) : (
      <PlainLogo url={url} />
    )
  }
}

const PlainLogo = styled.div`
  height: 90px;
  width: 300px;

  margin: 0 auto;

  background-image: url(${(props) => props.url});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

  ${media.smallerThanSmallScreen`
    width: 220px;
  `}
`

const ICLogo = styled(ImageContainer)`
  height: 90px;
  width: 300px;

  display: flex;
  flex-direction: column;
  justify-content: center;

  margin: 0 auto;

  ${media.smallerThanSmallScreen`
    width: 220px;
  `}
`

export default HubLogo
